import { ContainerProps, GroupBase, components } from "react-select";
import SelectOption from "../option/select-option";
import { FC } from "react";

type SelectContainerProps = ContainerProps<
  SelectOption,
  false,
  GroupBase<SelectOption>
> & {
  idForTesting: string | undefined;
};

const SelectContainerComponent: FC<SelectContainerProps> = (props) => {
  const { idForTesting, ...propsRest } = props;

  const SelectContainer = components.SelectContainer as React.ComponentType<
    ContainerProps<SelectOption, false, GroupBase<SelectOption>>
  >;

  return (
    <SelectContainer
      {...propsRest}
      innerProps={Object.assign({}, props.innerProps, {
        "data-test-id": idForTesting,
      })}
    />
  );
};

export default SelectContainerComponent;
